import { Component, OnInit } from "@angular/core";
import { Title } from "@angular/platform-browser";

import { MainConfig } from "@atenea-cms";
import { Reseller, ResellerService } from "../shared";

@Component({
  selector: "reseller-list",
  templateUrl: "./reseller-list.component.html",
  styleUrls: ["./reseller-list.component.scss"],
})
export class ResellerListComponent implements OnInit {
  resellers: Array<Reseller>;
  resellersFiltered: Array<Reseller> = [];
  reorder: boolean = false;
  draggedItem: number = null;

  constructor(
    private titleService: Title,
    private mainConfig: MainConfig,
    private resellerService: ResellerService
  ) {}

  ngOnInit() {
    this.titleService.setTitle("Distribuidores - " + this.mainConfig.cmsName);

    this.resellerService.getAll().subscribe((resellers) => {
      this.resellers = resellers;
    });
  }

  dragItem(e: Event, i: number) {
    e.stopPropagation();
    this.draggedItem = i;
  }

  dropItem(e: Event, i: number) {
    e.stopPropagation();
    this.resellersFiltered = this.reorderItems(
      this.resellersFiltered,
      this.draggedItem,
      i
    );
    this.draggedItem = null;
    this.resellerService.saveMultiple(this.resellersFiltered).subscribe();
  }

  cancelDrag() {
    if (this.draggedItem !== null) {
      this.draggedItem = null;
    }
  }

  private reorderItems(
    items: Array<any>,
    positionStart: number = null,
    positionEnd: number = null
  ) {
    if (positionStart != positionEnd) {
      let itemsCloned = items.slice();
      let itemSelected = items[positionStart];
      items = [];

      itemsCloned.forEach((item, i) => {
        if (positionStart > positionEnd) {
          if (i > positionStart || i < positionEnd) {
            items[i] = item;
          } else if (i == positionEnd) {
            items[i] = itemSelected;
            items[i + 1] = item;
          } else if (i != positionStart) {
            items[i + 1] = item;
          }
        } else {
          if (i < positionStart || i > positionEnd) {
            items[i] = item;
          } else if (i == positionEnd) {
            items[i] = itemSelected;
            items[i - 1] = item;
          } else if (i != positionStart) {
            items[i - 1] = item;
          }
        }
      });
    }

    items = items.map((x, y) => {
      x.position = y + 1;

      return x;
    });

    return items;
  }
}



// WEBPACK FOOTER //
// ./libs/atenea-cms-brand/src/resellers/reseller-list/reseller-list.component.ts